// extracted by mini-css-extract-plugin
export default {"donut":"DonutChart_donut__4mSbt","legend":"DonutChart_legend__cKwDO","legendItem":"DonutChart_legendItem__U6MxW","legendDot":"DonutChart_legendDot__C5cdi"};